import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
	children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
	const location = useLocation();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// Start invisible and fade in
		setIsVisible(false)

		// Small delay then fade in
		const timer = setTimeout(() => {
			setIsVisible(true)
		}, 50)
		return () => clearTimeout(timer)
	}, [location.pathname, location.hash])

	return (
		<div
			data-page-transition
			style={{ opacity: isVisible ? 1 : 0 }}
			className={`transition-opacity duration-500 ease-in-out`}>
			{children}
		</div>
	)
}
